"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var home;
        (function (home) {
            var infopanel;
            (function (infopanel) {
                class InitArgs {
                    constructor() {
                        this.activeUsersArray = [];
                        this.formEntriesArray = [];
                        this.latLongCountry = appn.emptyString;
                        this.postLatestEntries = appn.emptyString;
                        this.sevenDaysArray = [];
                        this.userPermissionFormEntries = false;
                        this.dataIndex = appn.emptyString;
                    }
                }
                let _initArgs;
                let _map;
                let _entriesLayers = [];
                let _totalEntries = 0;
                let _resultsWithoutGPS = 0;
                const _monthNames = [T('Jan'), T('Feb'), T('Mar'), T('Apr'), T('May'), T('Jun'), T('Jul'), T('Aug'), T('Sep'), T('Oct'), T('Nov'), T('Dec')];
                function init(args) {
                    _initArgs = args;
                    _map = appn.ui.mapInit('map', 0, 0, 11, false);
                    getEntries();
                    renderChart();
                }
                infopanel.init = init;
                appn.pubSub.subscribe(appn.pubSub.WINDOW_RESIZED, function (channel, data) {
                    if (!_map)
                        return;
                    _map.invalidateSize();
                });
                function getEntries() {
                    appn.ajax.post({
                        url: _initArgs.postLatestEntries,
                        dataType: 'json',
                        done: function (data) {
                            processResult(data);
                        },
                        fail: function () {
                            appn.toast.notify(appn.toast.Type.error, T('Failed to fetch map data.'));
                        }
                    });
                }
                function processResult(data) {
                    removeMarkers();
                    _resultsWithoutGPS = 0;
                    const countryLatLonBits = _initArgs.latLongCountry.split(',');
                    const countryLat = countryLatLonBits[0];
                    const countryLon = countryLatLonBits[1];
                    let firstEntryLatLng = L.latLng(countryLat, countryLon);
                    let firstPopup;
                    const bounds = [];
                    const markers = L.markerClusterGroup();
                    for (let i = 0; i < data.Entries.length; i++) {
                        const lat = data.Entries[i][0];
                        const lon = data.Entries[i][1];
                        if (lat !== 0 && lon !== 0) {
                            const entriesll = L.latLng(lat, lon);
                            bounds.push([entriesll.lat, entriesll.lng]);
                            const icon = L.divIcon({
                                html: '<div class="appn-mapPin"></div>' +
                                    '<div class="appn-mapShadow"></div>'
                            });
                            const entriesmark = new L.Marker(entriesll, { icon: icon });
                            markers.addLayer(entriesmark);
                            const popupText = getPopupTextHtml(data.Entries[i]);
                            const popup = entriesmark.bindPopup(popupText).on('popupopen', function (popup) {
                                $('abbr.timeago').timeago();
                            });
                            if (i === 0) {
                                firstPopup = popup;
                                firstEntryLatLng = entriesll;
                            }
                        }
                        else
                            _resultsWithoutGPS++;
                    }
                    _map.addLayer(markers);
                    _entriesLayers.push(markers);
                    updateUI(data);
                    if (bounds.length > 0) {
                        _map.fitBounds(bounds);
                        _map.setZoom(_map.getZoom() - 1);
                    }
                    else
                        _map.setView(firstEntryLatLng, 6);
                    if (firstPopup)
                        firstPopup.openPopup();
                }
                function getPopupTextHtml(entry) {
                    let popupTextHtml = '<div class="appnMapPopup">' +
                        '<h5>' + entry[2] + '</h5>' +
                        `<span><i class="fa fa-clock"></i> ${T('Captured')} ` + entry[4] + '</span><br>';
                    popupTextHtml += `<span>${entry[6]}</span><br>`;
                    if (_initArgs.userPermissionFormEntries)
                        popupTextHtml += '<a class="btn btn-link btn-sm pb-0" href="' + getDataUrl(entry) + `">${T('View Data')}</a><br>`;
                    popupTextHtml += `<span class="text-muted leaflet-popup-gpsstring"><i class="fa fa-map-marker"></i> ${entry[0]} ${entry[1]}</span>`;
                    return popupTextHtml + '</div>';
                }
                function updateUI(data) {
                    _totalEntries = data.iTotalRecords;
                    let totalText = appn.strings.noResultsFound;
                    if (_totalEntries > 0)
                        totalText = appn.strings.latestFormEntries;
                    $('#TotalsText').html(totalText);
                }
                function getDataUrl(data) {
                    const entryId = data[3];
                    const parts = data[5].match(/(\d+)/g);
                    const toDate = new Date(parts[0], parts[1] - 1, parts[2]);
                    const fromDate = toDate;
                    fromDate.setMonth(toDate.getMonth() - 6);
                    const fromDateStr = fromDate.getDate() + '-' + _monthNames[fromDate.getMonth()] + '-' + fromDate.getFullYear();
                    const toDateStr = toDate.getDate() + '-' + _monthNames[toDate.getMonth()] + '-' + toDate.getFullYear();
                    const queryString = appn.location.buildQueryString([
                        { name: 'entryId', value: entryId },
                        { name: 'dfilter', value: 'CustomRange' },
                        { name: 'fromdate', value: fromDateStr },
                        { name: 'todate', value: toDateStr }
                    ]);
                    return _initArgs.dataIndex + queryString;
                }
                function removeMarkers() {
                    for (let i = 0; i < _entriesLayers.length; i++)
                        _map.removeLayer(_entriesLayers[i]);
                    _entriesLayers = [];
                }
                function renderChart() {
                    const ctx = document.getElementById('myChart');
                    new Chart(ctx, {
                        type: 'line',
                        data: {
                            labels: [
                                _initArgs.sevenDaysArray[0],
                                _initArgs.sevenDaysArray[1],
                                _initArgs.sevenDaysArray[2],
                                _initArgs.sevenDaysArray[3],
                                _initArgs.sevenDaysArray[4],
                                _initArgs.sevenDaysArray[5],
                                _initArgs.sevenDaysArray[6]
                            ],
                            datasets: [
                                {
                                    pointRadius: 0,
                                    label: appn.strings.activeUsers,
                                    backgroundColor: $('#myChart-users').css('background-color'),
                                    borderColor: $('#myChart-users').css('background-color'),
                                    data: [
                                        _initArgs.activeUsersArray[0],
                                        _initArgs.activeUsersArray[1],
                                        _initArgs.activeUsersArray[2],
                                        _initArgs.activeUsersArray[3],
                                        _initArgs.activeUsersArray[4],
                                        _initArgs.activeUsersArray[5],
                                        _initArgs.activeUsersArray[6]
                                    ],
                                    fill: true
                                },
                                {
                                    pointRadius: 0,
                                    label: appn.strings.formEntries,
                                    fill: true,
                                    backgroundColor: $('#myChart-entries').css('background-color'),
                                    borderColor: $('#myChart-entries').css('background-color'),
                                    data: [
                                        _initArgs.formEntriesArray[0],
                                        _initArgs.formEntriesArray[1],
                                        _initArgs.formEntriesArray[2],
                                        _initArgs.formEntriesArray[3],
                                        _initArgs.formEntriesArray[4],
                                        _initArgs.formEntriesArray[5],
                                        _initArgs.formEntriesArray[6]
                                    ]
                                }
                            ]
                        },
                        options: {
                            maintainAspectRatio: false,
                            responsive: true,
                            title: {
                                display: false,
                                text: appn.strings.recentActivity
                            },
                            tooltips: {
                                mode: 'index',
                                intersect: false
                            },
                            hover: {
                                mode: 'nearest',
                                intersect: true
                            },
                            scales: {
                                xAxes: [
                                    {
                                        display: false,
                                        scaleLabel: {
                                            display: false,
                                            labelString: appn.strings.date
                                        },
                                        gridLines: {
                                            display: false
                                        }
                                    }
                                ],
                                yAxes: [
                                    {
                                        display: false,
                                        scaleLabel: {
                                            display: false,
                                            labelString: appn.strings.value
                                        },
                                        gridLines: {
                                            display: false
                                        }
                                    }
                                ]
                            }
                        }
                    });
                }
            })(infopanel = home.infopanel || (home.infopanel = {}));
        })(home = views.home || (views.home = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
